import React from "react";

function Descript() {
  return (
    <section class="">
      <div class=" columns">
        <div class="column is-two-fifths">
          <img class="globe-girl" alt="globe-girl" src="./img/descript.png" />
        </div>
        <div class="column has-text-centered des-back">
          <h3>Somthing Small</h3>
          <h1>Somthing About Spa and beauty </h1>
        </div>
      </div>
    </section>
  );
}

export default Descript;
